import { labelAddressActions } from '../config/actions';

const defaultState = {
  isLoading: false,
  data: [],
  created: false,
  updated: false,
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case labelAddressActions.LABEL_ADDRESS_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || false,
        created: state.created,
        error: null
      };
    case labelAddressActions.LABEL_ADDRESS_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        created: false,
        error: action.error
      };
    case labelAddressActions.LABEL_ADDRESS_NEW:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        created: true,
        error: null
      };
    case labelAddressActions.LABEL_ADDRESS_UPDATED:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        updated: true,
        error: null
      };
    case labelAddressActions.LABEL_ADDRESS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        created: false,
        error: null
      };
    case labelAddressActions.LABEL_ADDRESS_RESET:
      return {
        ...state,
        isLoading: false,
        data: [],
        created: false,
        error: null
      };
    default:
      return state;
  }
};
